import { Injectable } from '@angular/core';
import { CanLoad, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { GeneralService, UserService } from '../services/_index';
import 'rxjs/add/observable/of';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class NavigationGuard implements CanDeactivate<CanComponentDeactivate> {

    constructor(private generalService: GeneralService, private userService: UserService) {
    }
    

    canDeactivate(component: CanComponentDeactivate,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Promise<boolean> | boolean {
        let result = false;
        let url: string = state.url;
        //console.log('Url: ' + url);
        if (state.url.indexOf("deal-wizard") > 0)
        {
            //console.log('deal-wizard: ' + url);
            if (this.userService.isCustomer())
                return false;
        }

        if (localStorage.getItem('isDirty') == 'true')
            return this.generalService.showConfirmDialog("הנתונים לא יישמרו-האם להמשיך?");
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/guards/navigation.guard.ts